import { createTheme } from '@mui/material/styles';
import { brightThemeProps } from '../brightThemeProps';
import { enUS } from '@mui/material/locale';

export const brightThemeEN = createTheme(brightThemeProps, enUS);
